module.exports = __webpack_public_path__ + "static/Hero2-985cd79723d1301018f50f87d284b80a.png";